import { createClient, SupabaseClient } from '@supabase/supabase-js';

// Define the database types
export interface Database {
  public: {
    Tables: {
      projects: {
        Row: {
          id: number;
          job_number: string;
          name: string;
          status: string;
          types: string[];
          standard: string;
          created_at: string;
          project_lead: number | null;
          client: number | null;
          description: string | null;
        };
        Insert: {
          id?: number;
          job_number: string;
          name: string;
          status?: string;
          types?: string[];
          standard?: string;
          created_at?: string;
          project_lead?: number | null;
          client?: number | null;
          description?: string | null;
        };
        Update: {
          id?: number;
          job_number?: string;
          name?: string;
          status?: string;
          types?: string[];
          standard?: string;
          created_at?: string;
          project_lead?: number | null;
          client?: number | null;
          description?: string | null;
        };
      };
      team_members: {
        Row: {
          id: number;
          first_name: string;
          last_name: string;
          type: string;
          role: string;
        };
      };
      clients: {
        Row: {
          id: number;
          company_name: string;
        };
      };
      profiles: {
        Row: {
          id: string;
          team_member_id: number;
          email: string;
          created_at: string;
        };
      };
      timesheet_batches: {
        Row: {
          id: number;
          employee_id: string;
          week_ending_date: string;
          status: 'Draft' | 'Submitted' | 'Approved' | 'Rejected';
          submitted_at: string | null;
          approved_at: string | null;
          approved_by: string | null;
          created_at: string;
        };
        Insert: {
          id?: number;
          employee_id: string;
          week_ending_date: string;
          status?: 'Draft' | 'Submitted' | 'Approved' | 'Rejected';
          submitted_at?: string | null;
          approved_at?: string | null;
          approved_by?: string | null;
          created_at?: string;
        };
        Update: {
          id?: number;
          employee_id?: string;
          week_ending_date?: string;
          status?: 'Draft' | 'Submitted' | 'Approved' | 'Rejected';
          submitted_at?: string | null;
          approved_at?: string | null;
          approved_by?: string | null;
          created_at?: string;
        };
      };
      timesheet_entries: {
        Row: {
          id: number;
          batch_id: number;
          project_id: number;
          date: string;
          hours: number;
          description: string | null;
          start_time: string | null;
          end_time: string | null;
          is_stage: boolean | null;
          created_at: string;
          updated_at: string | null;
        };
        Insert: {
          id?: number;
          batch_id: number;
          project_id: number;
          date: string;
          hours: number;
          description?: string | null;
          start_time?: string | null;
          end_time?: string | null;
          is_stage?: boolean | null;
          created_at?: string;
          updated_at?: string | null;
        };
        Update: {
          id?: number;
          batch_id?: number;
          project_id?: number;
          date?: string;
          hours?: number;
          description?: string | null;
          is_stage?: boolean | null;
          created_at?: string;
          updated_at?: string | null;
        };
      };
    };
    Views: {
    };
  };
}

// Environment variables with fallbacks for local development
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'http://localhost:54321';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

// Create and export the Supabase client with auth configuration
export const supabase: SupabaseClient<Database> = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Types are already exported via the interface declaration above 